// frontend/src/components/PipelineMonitor/HistoricoExecucoes.tsx

import React from 'react';
import type { PipelineMetric, StatusEtapa } from '../../interfaces/pipeline.interface';
import './HistoricoExecucoes.css';

interface Props {
  historico: PipelineMetric[];
  carregando: boolean;
  onSelecionarTrace: (traceId: string) => void;
  traceIdAtivo: string | null;
}

const getStatusIcon = (status: StatusEtapa): string => {
  switch (status) {
    case 'SUCCESS': return '✅';
    case 'RUNNING': return '🔄';
    case 'STARTED': return '⏳';
    case 'FAILED':  return '❌';
    case 'SKIPPED': return '⏭️';
  }
};

const getStatusClass = (status: StatusEtapa): string => {
  switch (status) {
    case 'SUCCESS': return 'status-success';
    case 'RUNNING': return 'status-running';
    case 'STARTED': return 'status-pending';
    case 'FAILED':  return 'status-error';
    case 'SKIPPED': return 'status-pending';
  }
};

export const HistoricoExecucoes: React.FC<Props> = ({
  historico,
  carregando,
  onSelecionarTrace,
  traceIdAtivo,
}) => {
  if (carregando) {
    return (
      <div className="historico-card">
        <h3>📋 Histórico</h3>
        <div className="loading">Carregando...</div>
      </div>
    );
  }

  if (historico.length === 0) {
    return (
      <div className="historico-card">
        <h3>📋 Histórico</h3>
        <p className="empty">Nenhuma execução encontrada</p>
      </div>
    );
  }

  return (
    <div className="historico-card">
      <div className="historico-header">
        <h3>📋 Histórico</h3>
        <span className="total">{historico.length} execuções</span>
      </div>

      <div className="lista-execucoes">
        {historico.map(execucao => (
          <div
            key={execucao.id}
            className={`execucao-item ${
              traceIdAtivo === execucao.trace_id ? 'active' : ''
            }`}
            onClick={() => onSelecionarTrace(execucao.trace_id)}
          >
            <div className="execucao-info">
              <span className="status-icon">{getStatusIcon(execucao.status)}</span>
              <div className="execucao-detalhes">
                <span className="trace-id">{execucao.trace_id}</span>
                <span className="dataset-name">
                  {execucao.dataset_name ?? '—'}
                </span>
              </div>
              <span className={`status-badge ${getStatusClass(execucao.status)}`}>
                {execucao.status}
              </span>
            </div>

            <div className="execucao-meta">
              <span className="etapa">
                {execucao.nome_amigavel ?? execucao.stage}
              </span>
              <span className="data">{execucao.started_at ?? '—'}</span>
              <span className="duracao">{execucao.duration_ms ?? '—'}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};